import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// import RouteItems from "../../Routes/routes";
import RouteItems from "../../../Routes/routes";
import "./NewHeader.scss";

function Header({ pageTitle , letter }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Parse current route path
  const paths = location.pathname.split("/").filter(Boolean);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <header className="header">
      <div className="header-left">
        <nav className="breadcrumb m-0">
        {paths.length ? (
            <ul>
              {paths.map((path, index) => {
                const currentPath = `/${paths
                  .slice(0, index + 1)
                  .join("/")}`;
                const routeItem = RouteItems.find(
                  (item) => item.path === currentPath
                );
                const title = routeItem
                  ? routeItem.title
                  : path.replace(/-/g, " ");
                const isLast = index === paths.length - 1;
                const isFirst = index === 0;

                return (
                  <li className="page-title" key={index}>
                    {isFirst && (
                      <span className="first-letter">{letter}</span>
                    )}
                    {isLast ? (
                      <span>{title}</span>
                    ) : (
                      <Link to={currentPath}>{title}</Link>
                    )}
                  </li>
                );
              })}
            </ul>
          ) : (
            <h1 className="page-title">
              <span className="first-letter">{letter}</span>&nbsp;
              {pageTitle}
            </h1>
          )}
        </nav>
      </div>
    </header>
  );
}

export default Header;
